export var name = 'rankingList';
export var AccumulationType;
(function (AccumulationType) {
    AccumulationType["WEEKLY"] = "WEEKLY";
    AccumulationType["ALL_TIME"] = "ALL_TIME";
})(AccumulationType || (AccumulationType = {}));
